import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth-context";
import PatientDocuments from "../components/PatientDocuments";
import MyAppointments from "../components/MyAppointments";

const FollowUpCard = () => {
  const [eligible, setEligible] = useState(false);
  useEffect(() => { api.get("/me/follow-up").then(({ data }) => setEligible(data.eligible && data.mfa_enabled)).catch(() => {}); }, []);
  if (!eligible) return null;
  return (
    <div data-testid="dashboard-followup-card" className="p-6 bg-cream-100 border border-bronze-light/40 rounded-md flex flex-wrap items-center justify-between gap-4">
      <div>
        <div className="eyebrow">Returning patient</div>
        <div className="font-serif text-2xl mt-1">Book a follow-up consultation · £150</div>
        <p className="text-sm text-ink-muted mt-1">30 minutes with your consultant. Your details are filled in for you.</p>
      </div>
      <Link to="/follow-up" data-testid="dashboard-followup-btn" className="btn-primary">Book a follow-up</Link>
    </div>
  );
};

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div data-testid="dashboard-page" className="container-ccc py-12">
      <div className="grid lg:grid-cols-12 gap-10">
        <aside className="lg:col-span-3 p-6 bg-white border border-stone-200/60 rounded-md h-fit">
          <div className="eyebrow">Signed in as</div>
          <div className="font-serif text-2xl mt-2">{user.name}</div>
          <div className="text-sm text-ink-muted break-words">{user.email}</div>
          <nav className="mt-6 space-y-2 text-sm">
            <Link to="/dashboard" className="block py-2 px-3 rounded-sm bg-cream-100">My documents & visits</Link>
            <Link to="/enquiry" className="block py-2 px-3 hover:bg-cream-100 rounded-sm">Book an appointment</Link>
            <Link to="/patient-info" className="block py-2 px-3 hover:bg-cream-100 rounded-sm">What to expect</Link>
          </nav>
          <div className="mt-6 pt-6 border-t border-stone-200/60 text-xs text-ink-muted leading-relaxed">
            All documents are stored and transmitted securely. We never send clinical letters or test results by email.
          </div>
        </aside>

        <section className="lg:col-span-9 space-y-8">
          <div>
            <div className="eyebrow">Patient portal</div>
            <h1 className="font-serif text-4xl mt-3">Welcome, {user.name.split(" ")[0]}.</h1>
            <p className="mt-3 text-ink-muted max-w-2xl">
              Your secure home for clinic letters, test results and imaging reports. You can also send us things back — like home blood-pressure diaries or letters from your GP — without using unsecured email.
            </p>
          </div>

          <FollowUpCard />

          <PatientDocuments />

          <MyAppointments />
        </section>
      </div>
    </div>
  );
}
